import cx from "classnames";
import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Arrow3Left } from "@gaming/xds-react-js-icons";

import { useProgramFillColorPicker } from "../../../helpers/useProgramColorPicker";
import { useStrings } from "../../../localization/localizationHelpers";
import * as styles from "./LeftArrowIcon.module.css";

export const LeftArrowIcon = () => {
  const colorStyle = useProgramFillColorPicker();
  const [leftArrowIcon] = useStrings("leftArrowIcon");

  return (
    <Icon
      title={leftArrowIcon}
      className={cx(styles.leftArrow, colorStyle)}
      icon={Arrow3Left}
      iconSize={IconSize.Custom}
    />
  );
};
